import React from "react";
import { useTranslation } from "react-i18next";

const features = [
  {
    title: "High Quality",
    description:
      "high_quality_description",
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.0123 8.21198C12.966 8.21198 7.2334 13.9447 7.2334 20.991C7.2334 28.0374 12.9661 33.7701 20.0123 33.7701C27.0586 33.7701 32.7912 28.0374 32.7912 20.991C32.7912 13.9447 27.0586 8.21198 20.0123 8.21198ZM16.1325 11.3153C14.8278 12.9844 13.3208 15.7546 13.0714 19.8141H9.65418C10.0904 15.9489 12.6483 12.7174 16.1325 11.3153ZM9.65418 22.168H13.0714C13.3207 26.2275 14.8275 28.9976 16.1322 30.6668C12.6482 29.2646 10.0904 26.0331 9.65418 22.168ZM18.8354 30.1793C18.5539 29.8963 18.2578 29.567 17.9629 29.1871C16.4657 27.2588 15.6155 24.9019 15.4285 22.168H18.8354V30.1793H18.8354ZM18.8354 19.8141H15.4284C15.6154 17.0804 16.4656 14.7235 17.9628 12.795C18.2578 12.4152 18.5539 12.0858 18.8353 11.8028L18.8354 19.8141ZM30.3705 19.8141H26.9532C26.7039 15.7546 25.1969 12.9843 23.8921 11.3153C27.3763 12.7174 29.9341 15.9489 30.3705 19.8141ZM21.1893 11.7987C22.5651 13.1853 24.3088 15.7202 24.5946 19.8141H21.1893V11.7987ZM21.1893 30.1793V22.168H24.5962C24.4092 24.9017 23.559 27.2587 22.0618 29.1871C21.7668 29.5669 21.4708 29.8963 21.1893 30.1793ZM23.8924 30.6668C25.197 28.9977 26.7039 26.2275 26.9532 22.168H30.3704C29.9341 26.0331 27.3764 29.2646 23.8924 30.6668Z"
          fill="#1D4078"
        />
        <path
          d="M40 21.389C40 10.3609 31.028 1.38885 20 1.38885C8.97195 1.38885 0 10.3609 0 21.389C0 28.0576 3.31711 34.2676 8.87336 38.0006L10.1861 36.0467C5.28188 32.7517 2.35391 27.2722 2.35391 21.389C2.35391 11.6589 10.2699 3.74284 20 3.74284C29.7301 3.74284 37.6461 11.6589 37.6461 21.3891C37.6461 26.3931 35.5269 31.104 31.876 34.4281L32.0943 31.4326L29.7466 31.2615L29.2474 38.1121L36.098 38.6112L36.2691 36.2635L33.5739 36.0671C37.6426 32.3064 40 27.0106 40 21.389Z"
          fill="#1D4078"
        />
      </svg>
    ),
  },
  {
    title: "Fast Shipping",
    description: "fast_shipping_description",
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.0123 8.21198C12.966 8.21198 7.2334 13.9447 7.2334 20.991C7.2334 28.0374 12.9661 33.7701 20.0123 33.7701C27.0586 33.7701 32.7912 28.0374 32.7912 20.991C32.7912 13.9447 27.0586 8.21198 20.0123 8.21198ZM16.1325 11.3153C14.8278 12.9844 13.3208 15.7546 13.0714 19.8141H9.65418C10.0904 15.9489 12.6483 12.7174 16.1325 11.3153ZM9.65418 22.168H13.0714C13.3207 26.2275 14.8275 28.9976 16.1322 30.6668C12.6482 29.2646 10.0904 26.0331 9.65418 22.168ZM18.8354 30.1793C18.5539 29.8963 18.2578 29.567 17.9629 29.1871C16.4657 27.2588 15.6155 24.9019 15.4285 22.168H18.8354V30.1793H18.8354ZM18.8354 19.8141H15.4284C15.6154 17.0804 16.4656 14.7235 17.9628 12.795C18.2578 12.4152 18.5539 12.0858 18.8353 11.8028L18.8354 19.8141ZM30.3705 19.8141H26.9532C26.7039 15.7546 25.1969 12.9843 23.8921 11.3153C27.3763 12.7174 29.9341 15.9489 30.3705 19.8141ZM21.1893 11.7987C22.5651 13.1853 24.3088 15.7202 24.5946 19.8141H21.1893V11.7987ZM21.1893 30.1793V22.168H24.5962C24.4092 24.9017 23.559 27.2587 22.0618 29.1871C21.7668 29.5669 21.4708 29.8963 21.1893 30.1793ZM23.8924 30.6668C25.197 28.9977 26.7039 26.2275 26.9532 22.168H30.3704C29.9341 26.0331 27.3764 29.2646 23.8924 30.6668Z"
          fill="#1D4078"
        />
        <path
          d="M40 21.389C40 10.3609 31.028 1.38885 20 1.38885C8.97195 1.38885 0 10.3609 0 21.389C0 28.0576 3.31711 34.2676 8.87336 38.0006L10.1861 36.0467C5.28188 32.7517 2.35391 27.2722 2.35391 21.389C2.35391 11.6589 10.2699 3.74284 20 3.74284C29.7301 3.74284 37.6461 11.6589 37.6461 21.3891C37.6461 26.3931 35.5269 31.104 31.876 34.4281L32.0943 31.4326L29.7466 31.2615L29.2474 38.1121L36.098 38.6112L36.2691 36.2635L33.5739 36.0671C37.6426 32.3064 40 27.0106 40 21.389Z"
          fill="#1D4078"
        />
      </svg>
    ),
  },
  {
    title: "24/7 Support",
    description: "support_description.",
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.0123 8.21198C12.966 8.21198 7.2334 13.9447 7.2334 20.991C7.2334 28.0374 12.9661 33.7701 20.0123 33.7701C27.0586 33.7701 32.7912 28.0374 32.7912 20.991C32.7912 13.9447 27.0586 8.21198 20.0123 8.21198ZM16.1325 11.3153C14.8278 12.9844 13.3208 15.7546 13.0714 19.8141H9.65418C10.0904 15.9489 12.6483 12.7174 16.1325 11.3153ZM9.65418 22.168H13.0714C13.3207 26.2275 14.8275 28.9976 16.1322 30.6668C12.6482 29.2646 10.0904 26.0331 9.65418 22.168ZM18.8354 30.1793C18.5539 29.8963 18.2578 29.567 17.9629 29.1871C16.4657 27.2588 15.6155 24.9019 15.4285 22.168H18.8354V30.1793H18.8354ZM18.8354 19.8141H15.4284C15.6154 17.0804 16.4656 14.7235 17.9628 12.795C18.2578 12.4152 18.5539 12.0858 18.8353 11.8028L18.8354 19.8141ZM30.3705 19.8141H26.9532C26.7039 15.7546 25.1969 12.9843 23.8921 11.3153C27.3763 12.7174 29.9341 15.9489 30.3705 19.8141ZM21.1893 11.7987C22.5651 13.1853 24.3088 15.7202 24.5946 19.8141H21.1893V11.7987ZM21.1893 30.1793V22.168H24.5962C24.4092 24.9017 23.559 27.2587 22.0618 29.1871C21.7668 29.5669 21.4708 29.8963 21.1893 30.1793ZM23.8924 30.6668C25.197 28.9977 26.7039 26.2275 26.9532 22.168H30.3704C29.9341 26.0331 27.3764 29.2646 23.8924 30.6668Z"
          fill="#1D4078"
        />
        <path
          d="M40 21.389C40 10.3609 31.028 1.38885 20 1.38885C8.97195 1.38885 0 10.3609 0 21.389C0 28.0576 3.31711 34.2676 8.87336 38.0006L10.1861 36.0467C5.28188 32.7517 2.35391 27.2722 2.35391 21.389C2.35391 11.6589 10.2699 3.74284 20 3.74284C29.7301 3.74284 37.6461 11.6589 37.6461 21.3891C37.6461 26.3931 35.5269 31.104 31.876 34.4281L32.0943 31.4326L29.7466 31.2615L29.2474 38.1121L36.098 38.6112L36.2691 36.2635L33.5739 36.0671C37.6426 32.3064 40 27.0106 40 21.389Z"
          fill="#1D4078"
        />
      </svg>
    ),
  },
];
export default function SectionFeatures() {
  const { t } = useTranslation();

  return (
    <section className="py-12 w-full">
      <div className="max-w-6xl mx-auto px-4 w-full">
        {/* Grid for larger screens */}
        <div className="flex gap-10 max-sm:flex-col flex-wrap">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex flex-col space-y-6 rounded-md bg-white px-6 py-4 w-[285px] h-[200px]"
            >
              {feature.icon}

              <p className="text-gray-700 text-base" key={t(feature.description)}>
                {t(feature.description)} {/* Dynamically translated description */}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
